import { navigate } from '@teliaee/crm-components';
import { ALLOWED_LANGUAGES, languageSlug } from '../stores/TranslateStore';
export const toPath = (pathname) => {
    return pathname.split('/').filter((path) => path);
};
export const pathIncludesLang = (path) => {
    return path && path.length > 0 && ALLOWED_LANGUAGES.includes(path[0]);
};
export const addLanguageSlugToUrl = (url, currentLanguage) => {
    const htmlLink = document.createElement('a');
    htmlLink.href = url;
    let pathname = htmlLink.pathname;
    if (!pathname.startsWith('/')) {
        pathname = `/${pathname}`;
    }
    if (!pathIncludesLang(toPath(pathname))) {
        htmlLink.pathname = languageSlug(currentLanguage) + pathname;
    }
    return htmlLink.href;
};
export const removeLanguageSlug = (pathName) => {
    if (pathName.startsWith('/') && pathIncludesLang(toPath(pathName))) {
        return pathName.substring(pathName.indexOf('/', 1));
    }
    return pathName;
};
export const removeHashAndNavigate = (hash) => {
    const htmlLink = document.createElement('a');
    htmlLink.href = window.location.href;
    if (htmlLink.hash.indexOf(hash) > 0) {
        let replaced = htmlLink.hash.replace(hash, '');
        if (replaced === '#') {
            replaced = '';
        }
        navigate(htmlLink.pathname + htmlLink.search + replaced);
    }
};
